import { useTranslation } from 'react-i18next';

import { cn } from 'support/helpers/cn/cn';
import { SingleSparkleIcon } from 'components/CustomIcons/SingleSparkleIcon';
import { Tooltip, TooltipContent, TooltipTrigger } from 'components/Display/Tooltip/Tooltip';

type SuggestedContentIconProps = {
  mode: 'view' | 'edit';
  className?: string;
};

export const SuggestedContentIcon = ({ mode, className }: SuggestedContentIconProps) => {
  const { t } = useTranslation();

  const trigger =
    mode === 'view' ? (
      <div className={cn('relative size-3 shrink-0', className)}>
        <SingleSparkleIcon className="absolute inset-[-3.5px] size-[19px]" />
      </div>
    ) : (
      <span className="pointer-events-auto">
        <SingleSparkleIcon className={className ?? 'size-5'} />
      </span>
    );

  return (
    <Tooltip>
      <TooltipTrigger>{trigger}</TooltipTrigger>
      <TooltipContent>{t('webedi:viewDocument.suggestedContentIconTooltip')}</TooltipContent>
    </Tooltip>
  );
};
